import api from "./axios";
import type { MatchEvent } from "@/types";
import { paths } from "./paths";

export interface CreateMatchEventPayload {
  scorerId: string;
  assisterId?: string;
  teamId: number;
  isOwnGoal: boolean;
}

export const createMatchEvent = (
  matchId: string,
  data: CreateMatchEventPayload,
) =>
  api.post<MatchEvent>(paths.matches.events(matchId), data).then((r) => r.data);

export const getMatchEvents = (matchId: string) =>
  api.get<MatchEvent[]>(paths.matches.events(matchId)).then((r) => r.data);

export const getMatchScore = (matchId: string) =>
  api
    .get<{ red: number; blue: number }>(paths.matches.score(matchId))
    .then((r) => r.data);

export const deleteMatchEvent = (matchId: string, eventId: string) =>
  api.delete(paths.matches.event(matchId, eventId)).then((r) => r.data);
